import { useState } from 'react'
import { useQuery, useMutation } from 'react-query'
import { useTranslation } from 'next-i18next'

// Libs
import { toast } from 'react-toastify'
import { IFetchPromotionListParams, fetchPromotionList } from '@/api/fetchPromotionTicketList'
import { ISetPromotionTicket, setPromotionTicket } from '@/api/setPromotionTicket'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

export type TicketsData = {
  claimAt?: string
  couponCode: string
  couponId?: number
  couponName: string
  couponUsageRule?: string
  isSelect?: boolean
  isShare?: boolean
  promotionEndAt: string
  promotionId: number
  promotionStartAt: string
  target: number
  targetIds: number[]
  usageConditionDesc: string[]
  usageStatus: string
  usageStatusDesc: string
  /** 以這次結帳品項試算，單獨使用可折抵的金額 */
  estimatedDiscountAmount?: number
  /** 建議套用（可選取的券中折抵最多的一張），結帳頁預設套用 */
  isRecommended?: boolean
}

export const usePromotion = (isLogin: boolean, payload: IFetchPromotionListParams) => {
  const { skuList } = payload
  const { t } = useTranslation()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isRefetchData, setIsRefetchData] = useState<boolean>(false)

  const {
    data,
    remove: removePromotionDataCache,
    isFetched,
    isSuccess,
  } = useQuery([QUERY_KEY.FETCH_PROMOTION_TICKET_LIST, { skuList }], () => fetchPromotionList({ skuList }), {
    enabled: isLogin,
  })
  const { mutateAsync: ticketMutateAsync } = useMutation(setPromotionTicket)

  const claimPromotionCoupon = async (payload: ISetPromotionTicket) => {
    let apiRes: any = null

    try {
      const msg = t('Toast_Coupon_Redeem_Successfully')
      apiRes = await ticketMutateAsync(payload)

      removePromotionDataCache()
      setIsRefetchData(true)
      toast.success(msg)
    } catch (error: any) {
      toast.error(error.message)
    }

    return apiRes
  }

  return {
    isPromotionDataFetched: isFetched,
    isPromotionDataSuccess: isSuccess,
    promotionCouponData: (data?.tickets as TicketsData[]) || [],
    expiredPromotionCouponData: (data?.expiredTickets as TicketsData[]) || [],
    claimPromotionCoupon,
  }
}
